import { BuildConfig } from "./ConfigBlocks";
import { createContext } from "react";
import { Option } from "fp-ts/Option";
import { option } from "fp-ts";

export const BuildConfigContext = createContext<Option<BuildConfig>>(
  option.none
);
